export const orderStyles = {
  mainOpen: {
    width: "calc(100vw - 240px)",
  },
  mainClose: {
    width: "calc(100vw - 50px)",
  },
};
